import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClientRegisterComponent } from './client-register/client-register.component';

import { TermAndConditionsComponent } from './term-and-conditions/term-and-conditions.component';
import { CampaignRulesComponent } from './campaign-rules/campaign-rules.component';

const routes: Routes = [
  { path: '', redirectTo: '/vreau-freyashop', pathMatch: 'full' },
  { path: 'vreau-freyashop', component: ClientRegisterComponent },
  { path: 'termeni-si-conditii', component: TermAndConditionsComponent },
  { path: 'regulament-campanie', component: CampaignRulesComponent },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
